import { useState } from 'react';
import AdminLayout from '../components/AdminLayout';
import WhatsAppTemplatesSection from '../components/WhatsAppTemplatesSection';
import WhatsAppAutoRepliesSection from '../components/WhatsAppAutoRepliesSection';
import { apiFetch } from '../lib/api';

export default function AdminWhatsAppCenter() {
  const [tab, setTab] = useState<'templates' | 'auto-replies'>('templates');
  const waFetch = (path: string, init?: RequestInit) =>
    apiFetch(`/api/public/admin/whatsapp${path}`, init);

  return (
    <AdminLayout currentPage="WhatsApp 中心">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">WhatsApp 中心</h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          管理 Meta 官方模板、24 小時自動回覆、變數對應、發送渠道與測試發送。
        </p>
      </div>

      <div className="flex items-center gap-2 mb-6 border-b border-gray-200 dark:border-gray-700">
        <button
          onClick={() => setTab('templates')}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition ${
            tab === 'templates'
              ? 'border-orange-600 text-orange-600'
              : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
          }`}
        >
          已建立模板
        </button>
        <button
          onClick={() => setTab('auto-replies')}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition ${
            tab === 'auto-replies'
              ? 'border-orange-600 text-orange-600'
              : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
          }`}
        >
          24 小時自動回覆
        </button>
      </div>

      {tab === 'templates' && <WhatsAppTemplatesSection apiFetch={waFetch} />}
      {tab === 'auto-replies' && <WhatsAppAutoRepliesSection apiFetch={waFetch} />}
    </AdminLayout>
  );
}
